import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  backArrow: {
    width: '100%',
    maxWidth: '1680px',
    position: 'absolute',
    top: '100px',
    transform: 'translateX(-50%)',
    left: '50%',
    paddingLeft: '38px',
    [theme.breakpoints.down(1344)]: {
      top: '93px',
    },
    [theme.breakpoints.down('md')]: {
      top: '145px',
      paddingLeft: '14px',
    },
  },
  viewProfileCard: {
    backgroundColor: colors.blue.l45,
    color: colors.white,
    height: 80,
  },
  viewProfileCardContent: {
    padding: '16px 32px',
  },
  viewProfileButton: {
    backgroundColor: colors.blue.l60,
    color: colors.white,
    '&:hover': {
      backgroundColor: colors.blue.l60,
    },
  },
  button: {},
  fillHeight: {
    height: '100%',
  },
  otherTrades: {
    backgroundColor: colors.white,
  },
  businessProfileLayout: {
    backgroundColor: colors.white,
  },
  innerGridContainer: {
    [theme.breakpoints.down('lg')]: {
      flexBasis: '100%',
      width: '100%',
      maxWidth: '100%',
    },
  },
  container: {
    [theme.breakpoints.down('lg')]: {
      paddingLeft: '24px',
      paddingRight: '24px',
    },
  },
}));
